import React, { useState, useEffect, useRef } from "react";
import "./LazyImage.css";

const LazyImage = ({ src, alt, className = "" }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const imgRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    // Use Intersection Observer for lazy loading
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && containerRef.current && src) {
            // Load the image
            const img = new Image();
            img.onload = () => {
              if (imgRef.current) {
                imgRef.current.src = src;
                imgRef.current.style.opacity = "1";
              }
              setIsLoading(false);
              setHasError(false);
            };
            img.onerror = () => {
              setIsLoading(false);
              setHasError(true);
            };
            img.src = src;
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "50px",
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, [src]);

  return (
    <div
      ref={containerRef}
      className={`lazy-image-wrapper ${className}`}
    >
      {/* Actual image */}
      <img
        ref={imgRef}
        alt={alt}
        className={`lazy-image ${!isLoading ? "loaded" : ""} ${className}`}
        style={{ opacity: isLoading ? 0 : 1 }}
      />

      {/* Error state */}
      {hasError && (
        <div className="lazy-image-error">
          <p>Failed to load image</p>
        </div>
      )}
    </div>
  );
};

export default LazyImage;
